import Button from '@/components/Button'
import { Column } from '@/components/Table'
import Text from '@/components/Text'
import { leastText } from '@/constant'
import { ImageIcon } from '@/icon'
import { ApplicationShareInfo } from '@/types'
import { Message } from '@cx/ui'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import { Stack, TextField, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import React, { useCallback } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'

const Row = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}))

const ShareLink = ({ link, id }: { link: string; id?: string }) => {
  const handleClick = useCallback(() => {
    Message.success('复制成功')
  }, [id])

  return (
    <>
      <TextField
        disabled={true}
        fullWidth
        sx={{ borderRadius: '25px' }}
        value={link}
        InputProps={{
          endAdornment: (
            <CopyToClipboard aria-describedby={id} text={link} onCopy={handleClick}>
              <Button id={`copy-button${id}`} type='text' sx={{ fontSize: '14px' }}>
                复制链接
              </Button>
            </CopyToClipboard>
          ),
          sx: {
            '& > input': { textOverflow: 'ellipsis' },

            '&::before': {
              border: 'none !important',
            },
          },
        }}
      />
    </>
  )
}

export const shareInfoColumns: Column<ApplicationShareInfo & { label?: unknown }>[] = [
  {
    id: 'app_name',
    label: '产品',
    width: '240px',
    // @ts-ignore
    format: ({ row, value }: { row: ApplicationShareInfo; value: string }) => (
      <Row sx={{ gap: '8px' }}>
        <ImageIcon src={row?.logo_url} sx={{ width: '32px' }} />
        <Text size='xs'>{value}</Text>
      </Row>
    ),
  },
  {
    id: 'remark',
    label: '备注',
    ellipsis: true,
    width: '100px',
  },
  {
    id: 'url',
    label: '分享链接',
    format: ({ row, value }) => <ShareLink link={value as string} id={row?.app_id?.toString()} />,
  },
  {
    id: 'label',
    label: '',
    width: '60px',
    format: () => (
      <Stack>
        <Text size='xs'>今日</Text>
        <Text size='xs' sx={{ color: leastText }}>
          历史
        </Text>
      </Stack>
    ),
  },
  {
    id: 'hit_count',
    label: '点击数',
    labelIcon: (
      <Tooltip title='访问链接的次数'>
        <HelpOutlineIcon sx={{ fontSize: '14px', color: leastText }} />
      </Tooltip>
    ),
    width: '100px',
    format: ({ row, value }) => (
      <Stack>
        <Text size='xs'>{value as string}</Text>
        <Text size='xs' sx={{ color: leastText }}>
          {row?.hit_count_history}
        </Text>
      </Stack>
    ),
  },
  {
    id: 'register_count',
    label: '注册数',
    labelIcon: (
      <Tooltip title='通过链接注册百川云的用户数'>
        <HelpOutlineIcon sx={{ fontSize: '14px', color: leastText }} />
      </Tooltip>
    ),
    width: '100px',
    format: ({ row, value }) => (
      <Stack>
        <Text size='xs'>{value as string}</Text>
        <Text size='xs' sx={{ color: leastText }}>
          {row?.register_count_history}
        </Text>
      </Stack>
    ),
  },
]
